<script lang="ts">
  import { wikilinks } from '../wikilink';

  let { text, onpeek }: { text: string; onpeek: (slug: string) => void } = $props();

  // markdown-it is the heaviest dependency and only rendered bodies need it.
  let html = $state('');
  $effect(() => {
    const body = text;
    if (!body) {
      html = '';
      return;
    }
    let live = true;
    void import('../markdown').then((m) => {
      if (live) html = m.renderMarkdown(body);
    });
    return () => {
      live = false;
    };
  });
</script>

<div class="prose" use:wikilinks={onpeek}>{@html html}</div>
